<template>
    <!-- 对话框 -->
    <el-dialog title="信息管理" :visible.sync="show" :before-close="closeDialog" width="90%" class="addcash">
        <!-- 基本信息表单 -->
        <div class="form-box">
            <template>
                <el-form ref="form" :model="submit_data" label-width="100px" style="overflow-y: auto; height: 50vh; margin-top: 20px">
                    <el-form-item label="选择端口:">
                        <!-- 下拉选择端口 -->
                        <el-select v-model="submit_data.port" placeholder="请选择端口" style="width: 200px" @change="portChange" clearable>
                            <el-option label="司机端" value="driver"> </el-option>
                            <el-option label="乘客端" value="consumer"> </el-option>
                        </el-select>
                    </el-form-item>
                    <div v-if="submit_data.port != ''">
                        <div class="main-wrap clearfix">
                            <div>
                                <el-form-item label="分账接收方名称（需与营业执照的企业名称一致）:">
                                    <el-input
                                        v-model="submit_data.psReceiverName"
                                        :placeholder="submit_rules.psReceiverName.placeholder"
                                        style="width: 200px; margin-right: 5px"
                                    >
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="分账证明材料（业务合作合同）:">
<!--                                    <el-image-->
<!--                                        :preview-src-list="srcList"-->
<!--                                        v-if="img_url.psDocId"-->
<!--                                        :src="img_url.psDocId"-->
<!--                                        class="avatar"-->
<!--                                    ></el-image>-->

<!--                                    <el-upload-->
<!--                                        :class="img_url.psDocId ? 'border-none' : ''"-->
<!--                                        class="avatar-uploader"-->
<!--                                        :action="img_upload_url"-->
<!--                                        :show-file-list="false"-->
<!--                                        :on-success="psDocIdSuccess"-->
<!--                                        :before-upload="beforeAvatarUpload"-->
<!--                                        :headers="img_headers"-->
<!--                                    >-->
<!--                                        <el-button-->
<!--                                            slot="trigger"-->
<!--                                            v-if="img_url.psDocId"-->
<!--                                            @click="img_url.psDocId = ''"-->
<!--                                            style="width: 100px; margin-top: 10px"-->
<!--                                            >更换图片</el-button-->
<!--                                        >-->
<!--                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
<!--                                    </el-upload>-->


                                    <el-upload
                                            class="avatar-uploader picture-card"
                                            :class="{'hide':psDocId_beta.length>7}"
                                            :action="img_upload_url"
                                            list-type="picture-card"
                                            :limit="8"
                                            :before-upload="beforeAvatarUpload"
                                            :on-success="psDocIdSuccess"
                                            :headers="img_headers"
                                            :on-preview="handlePictureCardPreview"
                                            :on-remove="handleRemove">
                                        <i class="el-icon-plus"></i>
                                    </el-upload>


                                    <!--预览-->
                                    <el-dialog :visible.sync="dialogVisible" append-to-body>
                                        <img width="100%" :src="dialogImageUrl" alt="">
                                    </el-dialog>


                                </el-form-item>
                                <el-form-item>
                                    <p class="text-red">
                                        *注：盖章的分账证明材料（此份材料联系业务经理盖章办理）、入驻平台的合同，需加盖公章
                                    </p>
                                </el-form-item>
                                <el-form-item label="企业营业执照:">
                                    <el-image
                                        :preview-src-list="srcList"
                                        v-if="img_url.receiverCertFileId"
                                        :src="img_url.receiverCertFileId"
                                        class="avatar"
                                    ></el-image>
                                    <el-upload
                                        :class="img_url.receiverCertFileId ? 'border-none' : ''"
                                        class="avatar-uploader"
                                        :action="img_upload_url"
                                        :show-file-list="false"
                                        :on-success="receiverCertFileIdsuccess"
                                        :before-upload="beforeAvatarUpload"
                                        :headers="img_headers"
                                    >
                                        <el-button
                                            slot="trigger"
                                            v-if="img_url.receiverCertFileId"
                                            @click="img_url.receiverCertFileId = ''"
                                            style="width: 100px; margin-top: 10px"
                                        >
                                            更换图片
                                        </el-button>
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>

                                </el-form-item>
                                <el-form-item label="门头照:">
                                    <el-image
                                        :preview-src-list="srcList"
                                        v-if="img_url.storePicFileId"
                                        :src="img_url.storePicFileId"
                                        class="avatar"
                                    ></el-image>
                                    <el-upload
                                        :class="img_url.storePicFileId ? 'border-none' : ''"
                                        class="avatar-uploader"
                                        :action="img_upload_url"
                                        :show-file-list="false"
                                        :on-success="storePicFileIdsuccess"
                                        :before-upload="beforeAvatarUpload"
                                        :headers="img_headers"
                                    >
                                        <el-button
                                            slot="trigger"
                                            v-if="img_url.storePicFileId"
                                            @click="img_url.storePicFileId = ''"
                                            style="width: 100px; margin-top: 10px"
                                        >
                                            更换图片
                                        </el-button>
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>
                            </div>
                            <div>
                                <div style="font-weight: 700; text-indent: 10%">法人信息</div>
                                <el-form-item label="姓名:">
                                    <el-input v-model="submit_data.manName" style="width: 200px; margin-right: 5px"> </el-input>
                                </el-form-item>
                                <div style="font-weight: 700;text-indent: 7%">证件类型：身份证</div>
                                <el-form-item label="证件号码:">
                                    <el-input v-model="submit_data.certNo" maxlength="18" style="width: 200px; margin-right: 5px">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="证件生效日期:">
                                    <el-date-picker
                                        type="date"
                                        :placeholder="submit_rules.certEffectDate.placeholder"
                                        v-model="submit_data.certEffectDate"
                                        value-format="yyyyMMdd"
                                        style="width: 200px"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="证件失效日期:">
                                    <el-date-picker
                                        type="date"
                                        :placeholder="submit_rules.certExpireDate.placeholder"
                                        v-model="submit_data.certExpireDate"
                                        value-format="yyyyMMdd"
                                        style="width: 200px"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="联系手机:">
                                    <el-input v-model="submit_data.ctctCell" maxlength="11" style="width: 200px; margin-right: 5px">
                                    </el-input>
                                </el-form-item>
                                <div style="font-weight: 700; text-indent: 10%">身份证照片</div>
                                <el-form-item label="身份证人像面:">
                                    <el-image
                                        :preview-src-list="srcList"
                                        v-if="img_url.faceImageFileId"
                                        :src="img_url.faceImageFileId"
                                        class="avatar"
                                    ></el-image>
                                    <el-upload
                                        :class="img_url.faceImageFileId ? 'border-none' : ''"
                                        class="avatar-uploader"
                                        :action="img_upload_url"
                                        :show-file-list="false"
                                        :on-success="faceImageFileIdSuccess"
                                        :before-upload="beforeAvatarUpload"
                                        :headers="img_headers"
                                    >
                                        <el-button
                                            slot="trigger"
                                            v-if="img_url.faceImageFileId"
                                            @click="img_url.faceImageFileId = ''"
                                            style="width: 100px; margin-top: 10px"
                                        >
                                            更换图片
                                        </el-button>
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>

                                <el-form-item label="身份证国徽面:">
                                    <el-image
                                        :preview-src-list="srcList"
                                        v-if="img_url.nationalImageFileId"
                                        :src="img_url.nationalImageFileId"
                                        class="avatar"
                                    ></el-image>
                                    <el-upload
                                        :class="img_url.nationalImageFileId ? 'border-none' : ''"
                                        class="avatar-uploader"
                                        :action="img_upload_url"
                                        :show-file-list="false"
                                        :on-success="nationalImageFileIdSuccess"
                                        :before-upload="beforeAvatarUpload"
                                        :headers="img_headers"
                                    >
                                        <el-button
                                            slot="trigger"
                                            v-if="img_url.nationalImageFileId"
                                            @click="img_url.nationalImageFileId = ''"
                                            style="width: 100px; margin-top: 10px"
                                        >
                                            更换图片
                                        </el-button>
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>
                            </div>
                            <div>
                                <div style="font-weight: 700; text-indent: 9%">开户行信息</div>
                                <el-form-item label="省份:">
                                    <el-input v-model="submit_data.bankProvince" style="width: 200px; margin-right: 5px" disabled>
                                    </el-input>
                                </el-form-item>

                                <el-form-item label="城市:">
                                    <el-input v-model="submit_data.bankCity" style="width: 200px; margin-right: 5px" disabled> </el-input>
                                </el-form-item>
                                <el-form-item label="开户网点名称:">
                                    <el-input v-model="submit_data.bankName" style="width: 200px; margin-right: 5px"> </el-input>
                                </el-form-item>
                                <el-form-item label="银行账户名称:">
                                    <el-input v-model="submit_data.bankAccountName" style="width: 200px; margin-right: 5px"> </el-input>
                                    <div style="text-indent: -28%; font-size: 14px">例：广州银联网络支付有限公司</div>
                                </el-form-item>

                                <el-form-item label="银行账号:">
                                    <el-input v-model="submit_data.bankAccountNo" style="width: 200px; margin-right: 5px"> </el-input>
                                </el-form-item>
                                <el-form-item label="银行代码:">
                                    <el-select
                                        filterable
                                        v-model="value_bank_code"
                                        placeholder="请选择银行代码"
                                        @visible-change="bankCodeListsChange"
                                        @change="bankChange"
                                        clearable
                                        style="width: 200px; margin-right: 20px"
                                    >
                                        <el-option
                                            v-for="item in options_bank_code"
                                            :key="item.value"
                                            :label="item.bank_name"
                                            :value="item.bank_code"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="统一社会信用代码:">
                                    <el-input v-model="submit_data.receiverCertNo" style="width: 200px; margin-right: 5px"> </el-input>
                                </el-form-item>


                                <el-form-item label="开户许可证照片:">
                                    <el-image
                                        :preview-src-list="srcList"
                                        v-if="img_url.bankAccountFileId"
                                        :src="img_url.bankAccountFileId"
                                        class="avatar"
                                    ></el-image>
                                    <el-upload
                                        :class="img_url.bankAccountFileId ? 'border-none' : ''"
                                        class="avatar-uploader"
                                        :action="img_upload_url"
                                        :show-file-list="false"
                                        :on-success="bankAccountFileIdSuccess"
                                        :before-upload="beforeAvatarUpload"
                                        :headers="img_headers"
                                    >
                                        <el-button
                                            slot="trigger"
                                            v-if="img_url.bankAccountFileId"
                                            @click="img_url.bankAccountFileId = ''"
                                            style="width: 100px; margin-top: 10px"
                                        >
                                            更换图片
                                        </el-button>
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="电子联行号:">
                                    <el-input v-model="submit_data.bankNetCode" maxlength="12" style="width: 200px; margin-right: 5px">
                                    </el-input>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </el-form>
                <!-- 对话框底部按钮 -->
                <div style="display: flex; justify-content: center; margin-top: 20px">
                    <!-- <el-button type="primary" v-if="loading" icon="el-icon-loading" disabled></el-button>
                    <el-button type="primary" @click="onSubmit" v-else>确认</el-button> -->
                    <el-button type="primary" @click="onSubmit">确定</el-button>

                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </template>
        </div>

        <!-- 短信验证码组件，此页面是添加页面，所以给验证码组件传值busType要固定传0 -->
        <messageDialog
            :isShow="msg_isShow"
            :applyNo="applyNo"
            busType="0"
            :port="submit_data.port"
            @messageSucss="onSubmitDig"
        ></messageDialog>
    </el-dialog>
</template>

<script>
var _this;
import { config } from '../../../utils/config'; // 配置
import axios from 'axios'; // AJAX封装类
import messageDialog from './messageDialog.vue';

export default {
    props: {
        isShow: Boolean
    },
    components: {
        messageDialog
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            // 获取银行代码列表信息
            _this.getbankCodeLists();
            // 获取上传图片的地址
            this.img_upload_url = config.axios_imgURL;

            // 清空图片的路径
            this.img_url = {
                //分账证明材料ID
                psDocId: '',
                //身份证人像面照片
                faceImageFileId: '',
                //身份证国徽面照片
                nationalImageFileId: '',
                //开户许可证照片
                bankAccountFileId: '',
                //门头照
                storePicFileId: '',
                //接收方证件文件ID（营业执照）
                receiverCertFileId: ''
            };

            let cityName = JSON.parse(localStorage.getItem('login')).city.name;
            console.log(cityName);

            // x为字符串第一个'/'的下标
            let x = cityName.indexOf('/');
            console.log(cityName.indexOf('/'));

            // 省
            _this.submit_data.bankProvince = cityName.slice(0, x - 1);

            let y = cityName.slice(x + 2).indexOf('/');

            if (y < 0) {
                // 当前城市为市级

                // 市
                _this.submit_data.bankCity = cityName.slice(x + 2);
            } else {
                // 当前城市为区县级

                // 市

                _this.submit_data.bankCity = cityName.slice(x + 2).slice(0, y - 1);
            }
        }
    },

    data() {
        return {

            // loading: false,
            show: false,

            msg_isShow: false,

            // 分账上传图片预览显示
            dialogVisible:false,

            applyNo: '',

            dialogImageUrl:'',


            // 下拉搜索银行代码
            value_bank_code: '',
            options_bank_code: [],

            // 图片上传地址
            img_upload_url: '',

            srcList: [],

            //上传图片
            img_url: {
                //分账证明材料ID
                psDocId: '',
                //身份证人像面照片
                faceImageFileId: '',
                //身份证国徽面照片
                nationalImageFileId: '',
                //开户许可证照片
                bankAccountFileId: '',
                //门头照
                storePicFileId: '',
                //接收方证件文件ID（营业执照）
                receiverCertFileId: ''
            },

            //压缩质量
            imgQuality: 0.5,

            // 短信验证码
            message_data: '',

            // 短信验证码验证规则
            message_rules: {
                placeholder: '短信验证码',
                rules: {
                    required: true,
                    message: '短信验证码不能为空',
                    regulation: 'elt_str',
                    rulesData: 6
                }
            },

            psDocId_beta:[],
            // 表单数据
            submit_data: {
                //端口类型
                port: '',
                //企业名称
                psReceiverName: '',
                //分账证明材料ID
                psDocId: '',
                //统一社会信用代码
                receiverCertNo: '',
                //接收方证件文件ID
                receiverCertFileId: '',
                //门头照
                storePicFileId: '',
                //开户行省份
                bankProvince: '',
                //开户行城市
                bankCity: '',
                //开户网点名称
                bankName: '',
                //银行账号
                bankAccountNo: '',
                //银行账户名称
                bankAccountName: '',
                //银行代码
                bankCode: '',
                //开户许可证照片
                bankAccountFileId: '',
                //电子联行号
                bankNetCode: '',
                //法人姓名
                manName: '',
                //法人身份证号码
                certNo: '',
                //法人电话
                ctctCell: '',
                //证件生效日期 格式
                certEffectDate: '',
                //身份证人像面照片
                faceImageFileId: '',
                //证件失效日期 格式
                certExpireDate: '',
                //身份证国徽面照片
                nationalImageFileId: ''
            },

            submit_rules: {
                port: {
                    placeholder: '端口类型',
                    rules: {
                        required: true,
                        message: '端口错误',
                        regulation: 'gt_str',
                        rulesData: '0|1'
                    }
                },
                psReceiverName: {
                    placeholder: '分账接收方需在50字之内',
                    rules: {
                        required: true,
                        message: '分账接收方需在50字之内',
                        regulation: 'elt_str',
                        rulesData: 50
                    }
                },
                // psDocId: {
                //     placeholder: '分账证明材料',
                //     rules: {
                //         required: true,
                //         message: '分账证明材料哈希值错误',
                //         regulation: 'array',
                //         rulesData: 8
                //     }
                // },
                psDocId: {
                    placeholder: '分账证明材料',
                    rules: {
                        required: true,
                        message: '分账证明材料哈希值错误',
                        regulation: 'special',
                        rulesData: 'json_array'
                    }
                },
                receiverCertFileId: {
                    placeholder: '接收方证件文件',
                    rules: {
                        required: true,
                        message: '接收方证件文件哈希值错误',
                        regulation: 'special',
                        rulesData: 'json_array'
                    }
                },
                storePicFileId: {
                    placeholder: '门头照',
                    rules: {
                        required: true,
                        message: '门头照哈希值错误',
                        regulation: 'special',
                        rulesData: 'json_array'
                    }
                },
                manName: {
                    placeholder: '法人姓名需在2-8字之内',
                    rules: {
                        required: true,
                        message: '法人姓名需在2-8字之内',
                        regulation: 'between_str',
                        rulesData: [2, 8]
                    }
                },
                certNo: {
                    placeholder: '请输入法人身份证号码',
                    rules: {
                        required: true,
                        message: '法人身份证信息输入不正确',
                        regulation: 'special',
                        rulesData: 'id_card'
                    }
                },
                certEffectDate: {
                    placeholder: '请输入证件生效日期',
                    rules: {
                        required: true,
                        message: '请输入证件生效日期',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                certExpireDate: {
                    placeholder: '请输入证件失效日期',
                    rules: {
                        required: true,
                        message: '请输入证件失效日期',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                ctctCell: {
                    placeholder: '联系手机',
                    rules: {
                        required: true,
                        message: '联系手机长度不正确',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                },
                faceImageFileId: {
                    placeholder: '身份证人像面',
                    rules: {
                        required: true,
                        message: '身份证人像面哈希值错误',
                        regulation: 'special',
                        rulesData: 'json_array'
                    }
                },
                nationalImageFileId: {
                    placeholder: '身份证国徽面',
                    rules: {
                        required: true,
                        message: '身份证国徽面哈希值错误',
                        regulation: 'special',
                        rulesData: 'json_array'
                    }
                },
                bankProvince: {
                    placeholder: '开户行省份',
                    rules: {
                        required: true,
                        message: '省份未选择',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                bankCity: {
                    placeholder: '开户行城市',
                    rules: {
                        required: true,
                        message: '城市未选择',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },

                bankName: {
                    placeholder: '开户网点名称需在50字之内',
                    rules: {
                        required: true,
                        message: '开户网点名称需在50字之内',
                        regulation: 'elt_str',
                        rulesData: 50
                    }
                },
                bankAccountName: {
                    placeholder: '银行账户名称需在50字之内',
                    rules: {
                        required: true,
                        message: '银行账户名称需在50字之内',
                        regulation: 'elt_str',
                        rulesData: 50
                    }
                },
                bankAccountNo: {
                    placeholder: '请输入银行账号',
                    rules: {
                        required: true,
                        message: '银行账号信息输入不正确',
                        regulation: 'elt_str',
                        rulesData: '20'
                    }
                },
                bankCode: {
                    placeholder: '银行代码',
                    rules: {
                        required: true,
                        message: '银行代码',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                receiverCertNo: {
                    placeholder: '统一社会信用代码为18位',
                    rules: {
                        required: true,
                        message: '统一社会信用代码为18位',
                        regulation: 'eq_str',
                        rulesData: 18
                    }
                },


                bankAccountFileId: {
                    placeholder: '开户许可证照片',
                    rules: {
                        required: true,
                        message: '开户许可证照片哈希值错误',
                        regulation: 'special',
                        rulesData: 'json_array'
                    }
                },
                bankNetCode: {
                    placeholder: '电子联行号',
                    rules: {
                        required: true,
                        message: '电子联行号不能为空',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                }

            },
            // 上传图片的请求头
            img_headers: {
                token: '',
                'hash-key': '',
                platform: 'pc',
                'app-version': 'admin',
                port: 'admin',
                'city-tag': localStorage.getItem('city_tag'),
                'service-tag':localStorage.getItem('service_tag')
            }
        };
    },

    created() {
        _this = this;
    },
    methods: {

        handleRemove(file, fileList){

            let index;

            for(let i=0;i<_this.psDocId_beta.length;i++){
                if(_this.psDocId_beta[i] == file.response.data.img_hash){

                    index = i;
                    break;

                }

            }

            _this.psDocId_beta.splice(index,1);


            console.log(_this.psDocId_beta);



        },

        //分账上传图片预览方法
        handlePictureCardPreview(file) {
            console.log(file);



            this.dialogImageUrl = file.url;
            this.dialogVisible = true;

        },


        // 搜索银行代码
        getbankCodeLists() {
            _this
                .$post('/easy_cashier/bankCodeLists')
                .then((res) => {
                    _this.options_bank_code = res.data;
                })
                .catch((err) => {});
        },

        //搜索的下拉框弹出触发
        bankCodeListsChange(val) {
            _this.getbankCodeLists();
        },
        //选择下拉弹框值时触发
        bankChange(val) {
            console.log(val);

            _this.submit_data.bankCode = val;
        },
        toJSON(){

				_this.submit_data.psDocId = JSON.stringify(_this.psDocId_beta)
                console.log(_this.submit_data);

			},

        onSubmit() {

            // this.loading = true;
            // console.log(_this.submit_data);
            _this.toJSON();


            if (Number(_this.submit_data.certExpireDate) <= Number(_this.submit_data.certEffectDate)) {
                _this.$message.error('证件失效日期应大于证件生效日期');
                return;
            }

            // 分账接收方进件接口，此方法会自动发送短信验证码，接口请求成功后生成applyNo
            _this.$post('/easy_cashier/cashierApply', _this.submit_data, _this.submit_rules).then((res) => {
                _this.applyNo = res.data.response.data.applyNo;
                _this.msg_isShow = !_this.msg_isShow;

                // _this.timeInterval();
                // this.loading = false;

            });
        },

        // timeInterval() {
        //     t = setInterval(() => {
        //         if (_this.time > 0) {
        //             _this.time -= 1;
        //         } else {
        //             clearInterval(t);
        //         }
        //     }, 1000);
        // },


        // 文件上传
        cashierUpload(img_hash, submit_img_id) {


            return new Promise((resolve, reject) => {
                _this
                    .$post('/easy_cashier/cashierUpload', {
                        img_hash: img_hash,
                        port: _this.submit_data.port
                    })
                    .then((res) => {
                        console.log(111);
                        console.log(submit_img_id == 'psDocId');



                        if(submit_img_id == 'psDocId'){
                            console.log(_this.submit_data,'进来了');
                            _this.psDocId_beta.push(res.data.response.data.psFileId);

                            console.log(res.data.response.data.psFileId,'进来了');
                            // resolve();


                        }else{
                            _this.submit_data[submit_img_id] = res.data.response.data.psFileId;
                            console.log(_this.submit_data[submit_img_id],'没进来');
                            resolve();

                        }



                        console.log(_this.submit_data.port);
                        console.log(_this.submit_data);
                    })
                    .catch((err) => {});
            });
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;


                _this.submit_data={
                    //端口类型
                    port: '',
                    //企业名称
                    psReceiverName: '',
                    //分账证明材料ID
                    psDocId: '',
                    //统一社会信用代码
                    receiverCertNo: '',
                    //接收方证件文件ID
                    receiverCertFileId: '',
                    //门头照
                    storePicFileId: '',
                    //开户行省份
                    bankProvince: '',
                    //开户行城市
                    bankCity: '',
                    //开户网点名称
                    bankName: '',
                    //银行账号
                    bankAccountNo: '',
                    //银行账户名称
                    bankAccountName: '',
                    //银行代码
                    bankCode: '',
                    //开户许可证照片
                    bankAccountFileId: '',
                    //电子联行号
                    bankNetCode: '',
                    //法人姓名
                    manName: '',
                    //法人身份证号码
                    certNo: '',
                    //法人电话
                    ctctCell: '',
                    //证件生效日期 格式
                    certEffectDate: '',
                    //身份证人像面照片
                    faceImageFileId: '',
                    //证件失效日期 格式
                    certExpireDate: '',
                    //身份证国徽面照片
                    nationalImageFileId: ''
                };

        },
        // 提交按钮的请求方法
        onSubmitDig() {
            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();
        },

        // 门头照上传成功后执行
        async storePicFileIdsuccess(res, file) {
            if (res.code != 200) {
                _this.$message.error('图片上传失败');
                return;
            }

            // 将返回的哈希值存到submit_data对象
            _this.submit_data.storePicFileId = res.data.img_hash;
            await _this.cashierUpload(res.data.img_hash, 'storePicFileId');
            // 设置img标签显示的图片路径
            _this.img_url.storePicFileId = URL.createObjectURL(file.raw);

            _this.srcList[0] = this.img_url.storePicFileId;
            console.log(_this.srcList);
        },


        submitUpload() {
            this.$refs.upload.submit();
        },
        // 分账证明材料ID上传成功后执行
        async psDocIdSuccess(res, file) {
            if (res.code != 200) {
                _this.$message.error('图片上传失败');
                return;
            }
            console.log(res, '---------');
            console.log(file, '=============');
            // 将返回的哈希值存到submit_data对象
            // _this.submit_data.psDocId = res.data.img_hash;
            await _this.cashierUpload(res.data.img_hash, 'psDocId');
            // 设置img标签显示的图片路径
            _this.img_url.psDocId = URL.createObjectURL(file.raw);

            _this.srcList[0] = this.img_url.psDocId;
        },

        // 企业营业执照（receiverCertFileId）上传成功后执行
        async receiverCertFileIdsuccess(res, file) {
            if (res.code != 200) {
                _this.$message.error('图片上传失败');
                return;
            }

            // 将返回的哈希值存到submit_data对象
            _this.submit_data.receiverCertFileId = res.data.img_hash;
            await _this.cashierUpload(res.data.img_hash, 'receiverCertFileId');
            // 设置img标签显示的图片路径
            _this.img_url.receiverCertFileId = URL.createObjectURL(file.raw);

            _this.srcList[0] = this.img_url.receiverCertFileId;
        },

        // 开户许可证照片上传成功后执行
        async bankAccountFileIdSuccess(res, file) {
            if (res.code != 200) {
                _this.$message.error('图片上传失败');
                return;
            }

            // 将返回的哈希值存到submit_data对象
            _this.submit_data.bankAccountFileId = res.data.img_hash;
            await _this.cashierUpload(res.data.img_hash, 'bankAccountFileId');
            // 设置img标签显示的图片路径
            _this.img_url.bankAccountFileId = URL.createObjectURL(file.raw);

            _this.srcList[0] = this.img_url.bankAccountFileId;
        },
        // 身份证人像面照片上传成功后执行
        async faceImageFileIdSuccess(res, file) {
            if (res.code != 200) {
                _this.$message.error('图片上传失败');
                return;
            }

            // 将返回的哈希值存到submit_data对象
            _this.submit_data.faceImageFileId = res.data.img_hash;
            await _this.cashierUpload(res.data.img_hash, 'faceImageFileId');
            // 设置img标签显示的图片路径
            _this.img_url.faceImageFileId = URL.createObjectURL(file.raw);

            _this.srcList[0] = this.img_url.faceImageFileId;
        },
        // 身份证国徽面照片上传成功后执行
        async nationalImageFileIdSuccess(res, file) {
            if (res.code != 200) {
                _this.$message.error('图片上传失败');
                return;
            }

            // 将返回的哈希值存到submit_data对象
            _this.submit_data.nationalImageFileId = res.data.img_hash;

            await _this.cashierUpload(res.data.img_hash, 'nationalImageFileId');

            // 设置img标签显示的图片路径
            _this.img_url.nationalImageFileId = URL.createObjectURL(file.raw);

            _this.srcList[0] = this.img_url.nationalImageFileId;
        },

        // 图片压缩方法
        dataURItoBlob(dataURI, type) {
            var binary = atob(dataURI.split(',')[1]);
            var array = [];
            for (var i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], {
                type: type
            });
        },

        // 图片上传之前执行的函数
        beforeAvatarUpload(file) {
            // 添加请求头
            _this.img_headers.token = localStorage.getItem(config.localStorage_token_name);
            _this.img_headers['hash-key'] = _this.$hash_key();

            return new Promise((resolve) => {
                const reader = new FileReader();
                const image = new Image();
                image.onload = (imageEvent) => {
                    const canvas = document.createElement('canvas');
                    const context = canvas.getContext('2d');
                    const width = image.width * _this.imgQuality;
                    const height = image.height * _this.imgQuality;
                    canvas.width = width;
                    canvas.height = height;
                    context.clearRect(0, 0, width, height);
                    context.drawImage(image, 0, 0, width, height);
                    const dataUrl = canvas.toDataURL(file.type);
                    const blobData = _this.dataURItoBlob(dataUrl, file.type);
                    resolve(blobData);
                };
                reader.onload = (e) => {
                    image.src = e.target.result;
                };
                reader.readAsDataURL(file);
            });
        },

        portChange() {
            _this.submit_data.psDocId = '';
            _this.submit_data.faceImageFileId = '';
            _this.submit_data.nationalImageFileId = '';
            _this.submit_data.bankAccountFileId = '';
            _this.submit_data.storePicFileId = '';
            _this.submit_data.receiverCertFileId = '';

            _this.img_url = {
                //分账证明材料ID
                psDocId: '',
                //身份证人像面照片
                faceImageFileId: '',
                //身份证国徽面照片
                nationalImageFileId: '',
                //开户许可证照片
                bankAccountFileId: '',
                //门头照
                storePicFileId: '',
                //接收方证件文件ID（营业执照）
                receiverCertFileId: ''
            };

            _this.value_bank_code = '';
            _this.srcList = [];
        },

        // 判断图片的img_url是否存在
        imgUrlDeg() {
            if (
                _this.img_url.psDocId !== '' &&
                _this.img_url.receiverCertFileId !== '' &&
                _this.img_url.storePicFileId !== '' &&
                _this.img_url.bankAccountFileId !== '' &&
                _this.img_url.faceImageFileId !== '' &&
                _this.img_url.nationalImageFileId !== ''
            ) {
                return true;
            } else {
                _this.$message.error({
                    message: '未上传图片信息',
                    duration: 1500
                });
                return false;
            }
        }
    }
};
</script>
<style>
.addcash .el-dialog {
    margin-top: 8vh !important;
}
    .picture-card{
        display: flex;
        width: 100%!important;
        height: auto!important;
        flex-wrap: wrap;
    }
    .picture-card .el-upload-list{
        display: flex;
        flex-wrap: wrap;

    }

    .picture-card .el-upload--picture-card{
        width: 100px;
        height: 100px;
        line-height: 100px;
    }
    .picture-card .el-upload-list__item{
        width: 100px;
        height: 100px;
    }
    .hide.avatar-uploader .el-upload{
        display: none!important;
    }
</style>
<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
    height: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 100px;
    height: 100px;
    display: block;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}

.avatar-uploader img {
    display: block;
    width: 100%;
    height: 100%;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.verify_remarks {
    font-size: 14px;
    color: #606266;
}

.main-wrap{
    margin: 0 auto;
    width: 1750px;
    overflow-x: auto;
}
.main-wrap>div{

    width: 550px;
    float: left;

}

</style>
